<!-- <div class="d-flex flex-column justify-content-center align-items-center h-100vh">
	<i class="material-icons tablet-icon">tablet_android</i>
	<img src="assets/img/foster-logo.png" class="img-logo" alt="">
</div> -->
<!-- <div style="background-color: #ff5b40;">
	<div style="height: 100vh;padding-top: 260px;max-width: 1000px;margin: auto;background-color: #ff5b40;">
		<object>
			<embed src="assets/img/loader-logo.svg">
		</object>
	</div>
</div> -->

<div class="logo-wrapper">
	<img src="" class="brand-logo">
</div>